import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'antd';
import autobind from 'react-autobind';
import nanoid from 'nanoid';
import translate from 'app/translations';
import moment from 'moment-timezone';
import { messageShape } from '../AgentProfilePropType';

import './MessageList.scss';

const { Panel } = Collapse;

export class MessageList extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  render() {
    const { messageList } = this.props;

    return (
      <div className="message-list">
        {messageList && messageList.length > 0 && (
          <Collapse
            accordion
            defaultActiveKey={`${messageList[0].id}`}
          >
            {
              messageList.map(message => (
                <Panel
                  header={(
                    <div className="panel-heading">
                      <strong className="timestamp">
                        {message.createdDate ? moment(message.createdDate).format('MMM D, YYYY') : ''}
                      </strong>
                      <span>{message.notes}</span>
                    </div>
                  )}
                  key={message.id}
                >
                  <div>
                    <div>
                      <strong className="sub-heading">
                        {this.t('MessageList.fromHeading')}
                      </strong>
                      <span>{message.name}</span>
                    </div>
                    <div>
                      <strong className="sub-heading">{this.t('MessageList.noteHeading')}</strong>
                      {
                        message.notes.split(/(\n)/g).map(n => <p key={nanoid()}>{n}</p>)
                      }
                    </div>
                  </div>
                </Panel>
              ))
            }
          </Collapse>
        )}
      </div>
    );
  }
}

MessageList.propTypes = {
  messageList: PropTypes.arrayOf(messageShape).isRequired,
};

export default MessageList;
